import { GraphQL } from '@guestgoodie/graphql'

export const locales: Partial<
  Record<GraphQL.AppLocale, { label: string; flag: string }>
> = {
  [GraphQL.AppLocale.En]: {
    label: 'English',
    flag: '🇺🇸🇬🇧'
  },
  [GraphQL.AppLocale.De]: {
    label: 'Deutsch',
    flag: '🇦🇹🇩🇪'
  },
  [GraphQL.AppLocale.It]: {
    label: 'Italiano',
    flag: '🇮🇹'
  },
  [GraphQL.AppLocale.Es]: {
    label: 'Español',
    flag: '🇪🇸🇲🇽'
  },
  [GraphQL.AppLocale.Ko]: {
    label: '한국어',
    flag: '🇰🇷'
  },
  [GraphQL.AppLocale.Ja]: {
    label: '日本語',
    flag: '🇯🇵'
  },
  [GraphQL.AppLocale.Fr]: {
    label: 'Français',
    flag: '🇫🇷'
  },
  [GraphQL.AppLocale.Th]: {
    label: 'ไทย',
    flag: '🇹🇭'
  },
  [GraphQL.AppLocale.Zh]: {
    label: '简体中文',
    flag: '🇨🇳'
  }
}

export function localesLabels(locs: GraphQL.AppLocale[]) {
  return locs.map(loc => {
    const locale = locales[loc]

    if (!locale) return loc.toLowerCase()
    return `${locale.flag} ${locale.label}`
  })
}

export function localesAsOptions(locs: GraphQL.AppLocale[]) {
  return locs
    .toSorted((locA, locB) => {
      const hasFlagA = !!locales[locA]
      const hasFlagB = !!locales[locB]

      if (hasFlagA && !hasFlagB) return -1
      if (!hasFlagA && hasFlagB) return 1
      return 0
    })
    .map(loc => {
      const locale = locales[loc]

      if (!locale) {
        return {
          label: loc.toLowerCase(),
          value: loc
        }
      }

      return {
        label: `${locale.flag} ${locale.label}`,
        value: loc
      }
    })
}

export const allSupportedLocales = Object.values(GraphQL.AppLocale)
export const allLocalesAsOptions = localesAsOptions(allSupportedLocales)
